import { render, staticRenderFns } from "./battalionpanel.vue?vue&type=template&id=4ca954b1&scoped=true"
import script from "./battalionpanel.vue?vue&type=script&lang=js"
export * from "./battalionpanel.vue?vue&type=script&lang=js"
import style0 from "./battalionpanel.vue?vue&type=style&index=0&id=4ca954b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca954b1",
  null
  
)

export default component.exports